import { v4 } from 'uuid'

// Keep an uncertain request's original payload across explicit retries/reloads.
// The server binds this UUID to one committed order, never to a new reservation.
export function readReservationRequest(scope) {
  try {
    const saved = JSON.parse(sessionStorage.getItem(`reservation-request:${scope}`) || 'null')
    if (saved && /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(saved.requestUUID) && saved.variables) return saved
  } catch (_) { /* In-memory protection still works when storage is unavailable. */ }

  return null
}

export function createReservationRequest(scope, variables) {
  const request = { requestUUID: v4(), variables: JSON.parse(JSON.stringify(variables)) }
  try { sessionStorage.setItem(`reservation-request:${scope}`, JSON.stringify(request)) } catch (_) { /* Optional storage. */ }

  return request
}

export function clearReservationRequest(scope, request) {
  try {
    const saved = readReservationRequest(scope)
    if (saved && saved.requestUUID === request.requestUUID) sessionStorage.removeItem(`reservation-request:${scope}`)
  } catch (_) { /* Optional storage. */ }
}

export function isReservationRejected(result) {
  const errors = result && (result.graphQLErrors || result.errors)

  return Array.isArray(errors) && errors.length > 0 && errors.every(error => error.extensions && error.extensions.code === 'RESERVATION_REJECTED')
}

export function isReservationExpired(result) {
  const errors = result && (result.graphQLErrors || result.errors)

  return Array.isArray(errors) && errors.some(error => error.extensions && error.extensions.code === 'RESERVATION_EXPIRED')
}


// Display only: payment authority and money arithmetic remain on the server.
export function reservationOrderAmount(value) {
  const match = String(value == null ? '' : value).trim().match(/^(?:[A-Z]{3}\s+)?(\d+(?:\.\d{1,2})?)(?:\s+[A-Z]{3})?$/)

  return match ? Number(match[1]) : NaN
}
